import { useState } from 'react';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import { useSites } from '../../../context/SiteContext';
import { buildSnippet } from '../../../lib/snippet';

export default function SiteDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { sites, deleteSite, setCurrentSite } = useSites();
  const site = sites.find((s) => s.id === id);
  const [copied, setCopied] = useState(false);

  if (!site) return <Navigate to="/sites" replace />;

  const snippet = buildSnippet(site.trackingCode);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(snippet);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="max-w-3xl">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="font-heading text-2xl font-bold text-foreground-950">{site.name}</h1>
          <p className="mt-1 text-sm text-foreground-600">{site.domain}</p>
        </div>
        <Link to="/sites" className="text-sm text-foreground-600 hover:text-primary-600">
          返回列表
        </Link>
      </div>

      <section className="mt-6 rounded-lg border border-background-200 bg-background-50 p-6">
        <div className="flex items-center justify-between gap-3">
          <h2 className="font-heading text-lg font-semibold text-foreground-950">统计代码</h2>
          <span className="text-xs px-2 py-1 rounded-full bg-secondary-100 text-secondary-800">
            {site.trackingCode}
          </span>
        </div>
        <p className="mt-2 text-sm text-foreground-600">
          把下面这段代码粘贴到网站所有页面的 {'</body>'} 前即可开始采集。
        </p>
        <pre className="mt-4 overflow-x-auto rounded-md bg-foreground-950 text-background-50 p-4 text-xs leading-relaxed">
          {snippet}
        </pre>
        <button
          type="button"
          onClick={copy}
          className="mt-4 px-4 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md"
        >
          {copied ? '已复制' : '复制代码'}
        </button>
      </section>

      <section className="mt-4 rounded-lg border border-background-200 bg-background-50 p-6">
        <h2 className="font-heading text-lg font-semibold text-foreground-950">安装指引</h2>
        <ol className="mt-4 space-y-3 text-sm text-foreground-700">
          <li>1. 复制上方统计代码。</li>
          <li>2. 粘贴到网站公共模板底部，确保每个页面都会加载。</li>
          <li>3. 发布后访问任意页面，回到「实时访客」即可看到数据。</li>
        </ol>
      </section>

      <section className="mt-4 rounded-lg border border-background-200 bg-background-50 p-6">
        <h2 className="font-heading text-lg font-semibold text-foreground-950">查看统计</h2>
        <p className="mt-2 text-sm text-foreground-600">
          代码安装后访问网站，即可在实时访客和综合报告里看到数据。
        </p>
        <div className="mt-4 flex flex-wrap gap-3">
          <Link
            to="/dashboard"
            onClick={() => setCurrentSite(site.id)}
            className="px-4 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 rounded-md"
          >
            打开数据看板
          </Link>
        </div>
      </section>

      <button
        type="button"
        onClick={() => {
          if (window.confirm(`确定删除站点「${site.name}」及其访问数据吗？`)) {
            deleteSite(site.id);
            navigate('/sites');
          }
        }}
        className="mt-6 text-sm text-primary-700 hover:text-primary-800"
      >
        删除此站点
      </button>
    </div>
  );
}
